<template>
    <multiselect :disabled="this.disabled" v-model="valueSelected" :options="provinces" track-by="uuid" label="name"
        :multiple="false" :allowEmpty="false" placeholder="Provincia" selectedLabel="" selectLabel="" deselectLabel=""
        @select="notifyChange"></multiselect>
</template>
<script>

import Multiselect from "vue-multiselect";
import { getProvinces } from "../../api/location-api";

export default {
    name: "NewLocationProvinceSelector",
    components: {
        Multiselect,
    },

    props: {
        communitySelected: Object,
        provinceSelected: Object,
        initialProvince: String,
        disabled: Boolean,
        onSelected: Function,
        onFieldClear: Function,
        fieldClearArray: Array,
        communityShowDefault: Boolean,
    },
    data: function () {
        return {
            provinces: [],
            valueSelected: null,
        };
    },
    async mounted() {
        
        if(!this.communityShowDefault){
            await this.getProvinceList(null);
        }
        
    },
    methods: {
        notifyChange: function (value) {
            this.onSelected(value);
            this.onFieldClear([ 'town','postalCode' ]);
        },

        async getProvinceList(value) {
            getProvinces(value).then(provinces => {
                
                this.provinces = provinces;
                if (this.provinceSelected !== null && this.provinceSelected !== undefined) {
                    let findedProvince = this.provinces.find(province => province.uuid === this.provinceSelected.uuid);
                    this.valueSelected = findedProvince;
                    this.onSelected(findedProvince);
                }else if(this.initialProvince !== null && this.initialProvince !== undefined) {
                let findedProvince = this.provinces.find(province => province.name === this.initialProvince);
                this.valueSelected = findedProvince;
                this.onSelected(findedProvince);
            }
            })
        }


    },
    watch: {
        communitySelected: async function (value) {
            if(value !== null && value !== undefined) {
            await this.getProvinceList(value.uuid);
            }
        },
        
        fieldClearArray: function (value) {
            if (value.includes('province')) {
                this.valueSelected = null;
                this.onSelected(null);
            }
        }

    }
}

</script>
